import { useState, useEffect } from "react";
import { X, Download, Smartphone, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/hooks/useInstallPrompt";

const InstallPrompt = () => {
  const { isInstallable, isInstalled, isIOS, isMobile, promptInstall } = useInstallPrompt();
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if dismissed recently
    const dismissed = localStorage.getItem("installPromptDismissed");
    if (dismissed) {
      const dismissedTime = parseInt(dismissed);
      if (Date.now() - dismissedTime < 7 * 24 * 60 * 60 * 1000) {
        return;
      }
    }

    // Show prompt after delay for mobile devices or when installable
    if (isMobile || isInstallable) {
      const timer = setTimeout(() => setShowPrompt(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [isMobile, isInstallable]);

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem("installPromptDismissed", Date.now().toString());
  };

  if (isInstalled || !showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50 animate-fade-in">
      <div className="bg-card border border-border rounded-xl p-4 shadow-lg">
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
        
        <div className="flex items-start gap-3">
          <div className="bg-primary/10 p-2 rounded-lg shrink-0">
            <Smartphone className="h-6 w-6 text-primary" />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-foreground text-sm">
              Install Oz Coaching
            </h3>
            
            {isIOS ? (
              <div className="mt-1">
                <p className="text-xs text-muted-foreground">
                  Tap the <span className="font-medium">Share</span> button, then <span className="font-medium">"Add to Home Screen"</span> for quick access.
                </p>
              </div>
            ) : isInstallable ? (
              <div className="mt-1">
                <p className="text-xs text-muted-foreground mb-2">
                  Add to your home screen for quick access and offline use.
                </p>
                <Button 
                  onClick={promptInstall} 
                  size="sm" 
                  className="h-8 text-xs"
                >
                  <Download className="h-3 w-3 mr-1" />
                  Install App
                </Button>
              </div>
            ) : (
              <div className="mt-1">
                <p className="text-xs text-muted-foreground">
                  Tap the <span className="font-medium">menu (⋮)</span>, then <span className="font-medium">"Add to Home Screen"</span> or <span className="font-medium">"Install App"</span>.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
